import { useEffect, useRef } from 'react'

import { useLoaderStore } from '@/store/loader'

type UseHomeHeroImageLoaderProps = {
  imageUrls: (string | undefined)[]
  enabled?: boolean
}

export const useHomeHeroImageLoader = ({
  imageUrls,
  enabled = true
}: UseHomeHeroImageLoaderProps) => {
  const setLoaderState = useLoaderStore((state) => state.setLoaderState)
  const notifiedRef = useRef(false)

  useEffect(() => {
    if (!enabled) return
    if (notifiedRef.current) return

    const validUrls = imageUrls.filter(Boolean) as string[]

    if (validUrls.length === 0) {
      notifiedRef.current = true
      setLoaderState({ heroLoaded: true })
      return
    }

    let cancelled = false
    let loadedCount = 0

    const onLoad = () => {
      loadedCount++
      if (!cancelled && loadedCount >= validUrls.length && !notifiedRef.current) {
        notifiedRef.current = true
        setLoaderState({ heroLoaded: true })
      }
    }

    const images = validUrls.map((url) => {
      const img = new Image()
      img.src = url
      // Se l'immagine è già in cache, complete è true subito
      if (img.complete) {
        onLoad()
      } else {
        img.onload = onLoad
        img.onerror = onLoad
      }
      return img
    })

    return () => {
      cancelled = true
      images.forEach((img) => {
        img.onload = null
        img.onerror = null
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])
}
